import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectTypeDefinitionsFetched, {
	type SubjectTypeDefinitionsFetchedAction,
	type SubjectTypeDefinitionsFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';
import subjectTypeDefinitionsFetchFailed, {
	type SubjectTypeDefinitionsFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetchFailed';
import type FetchSubjectTypeDefinitions from '@Application/SubjectTypeDefinitions/Queries/FetchSubjectTypeDefinitions';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeDefinitionsFetchedAction | SubjectTypeDefinitionsFetchFailedAction;

export default (query: FetchSubjectTypeDefinitions) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectTypeDefinitionsFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/subject-type-definitions`,
			);

			const action = subjectTypeDefinitionsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeDefinitionsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
